<template>
  <el-dialog title="修改预付明细备注" :visible.sync="centerDialogVisible" class="remark-dialog" @close="closeDialog" width="30%" center>
    <el-form label-position="right" label-width="90px" :model="remarkData">
      <el-form-item label="媒体商ID：">
        <el-input v-model="remarkData.UserId" disabled></el-input>
      </el-form-item>
      <el-form-item label="预付信息：">
        <el-input v-model="remarkData.BusinessId" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input type="textarea" v-model="remarkData.Remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog">确定</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  data() {
    return {
      remarkData: {
        UserId: "",
        BusinessId: "",
        Remark: ""
      }
    };
  },
  props: {
    dialogPragram: Object,
    isShowdialog: Boolean
  },
  computed: {
    centerDialogVisible() {
      for (var key in this.remarkData) {
        this.remarkData[key] = this.dialogPragram[key];
      }
      return this.isShowdialog;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    confirmDialog() {
      this.dialogPragram.callback(this.remarkData);
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";
.remark-dialog {
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/change-billRemark-dialog.vue